<template>
    <b-col cols="12" lg="6" class="py-sm-64 py-lg-0">
      <b-row align-v="center" align-h="center" class="h-100 mx-4 mx-sm-n32">
        <b-col
          cols="12"
          md="9"
          xl="7"
          class="col-xxxl-5 px-8 px-sm-0 pt-24 pb-48"
        >
          <h1 class="mb-0 mb-sm-24">Поздравляем! Вы успешно зарегистрировались.</h1>

          <footer-item />
        </b-col>
      </b-row>
    </b-col>
  </template>
  
  <script>
  import {
    BRow,
    BCol,
    BButton,
    BLink,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
  } from "bootstrap-vue";
  
  import LeftItem from "../LeftItem.vue";
  import FooterItem from "../FooterItem.vue";
  
  export default {
    components: {
      BRow,
      BCol,
      BButton,
      BLink,
      BForm,
      BFormGroup,
      BFormInput,
      BFormCheckbox,
      LeftItem,
      FooterItem,
    },
    methods: {
      nextCick() {
          this.$emit("nextSlide");
      }
    }
  };
  </script>
  